import moment from "moment";
import React from "react";
import { Alert, Button } from "react-bootstrap";
import { AutoSizer, Column, SortDirection, Table } from "react-virtualized";
import { ServerActions } from "../actions/serverActions";
import { outageStore } from "../stores/outage";
import { ContentBox } from "./admin/ContentBox";

import "../css/adminScreen.css";
import OutageEdit from "./outageEdit";

function getStateFromStores() {
  return {
    data: outageStore.getOutageList(),
    loading: outageStore.isLoadingOutageList(),
    sortBy: "",
    disableHeader: false,
    useDynamicRowHeight: true,
    sortDirection: SortDirection.ASC,
    rowHeight: 23,
    headerHeight: 45,
    overscanRowCount: 10,
  };
}

export class OutageList extends React.Component {
  constructor(props) {
    super(props);
    this.state = getStateFromStores();
  }

  componentDidMount() {
    $("#mainSchematic").remove();
    document.title = "Outage List";
    ServerActions.getOutageList();
    outageStore.subscribe(this._onChange);
  }

  componentWillUnmount() {
    outageStore.unsubscribe(this._onChange);
  }

  _onChange = () => {
    this.setState(getStateFromStores());
  };

  _rowClassName = ({ index }) => {
    if (index < 0) {
      return "headerRow";
    } else {
      return index % 2 === 0 ? "oddRow" : "evenRow";
    }
  };

  _noRowsRenderer() {
    return <div className="noRows">No rows found</div>;
  }

  _getRestctionTimeZone = (item) => {
    let filterRestrictionTimeZone = "";
    if (
      item.restrictionTimeZone != null &&
      item.restrictionTimeZone.length == 6
    ) {
      filterRestrictionTimeZone = item.restrictionTimeZone;
    } else {
      const m = moment(item.issueTime, "YYYY-MM-DD HH:mm:ss");
      if (!m.isValid()) {
        filterRestrictionTimeZone = "N/A";
      } else {
        item.restrictionTimeZone = m.format("HH:mm") + item.restrictionTimeZone;
        filterRestrictionTimeZone = item.restrictionTimeZone;
      }
    }
    return filterRestrictionTimeZone;
  };

  _sort = ({ sortBy, sortDirection }) => {
    const comparer = (a, b) => {
      if (sortDirection === "ASC") {
        return a[sortBy] > b[sortBy] ? 1 : -1;
      } else if (sortDirection === "DESC") {
        return a[sortBy] < b[sortBy] ? 1 : -1;
      }
    };

    const rows =
      sortDirection === "NONE"
        ? this.state.originalRows.slice(0)
        : this.state.data.sort(comparer);

    this.setState({ rows, sortBy, sortDirection });
  };

  onRowDoubleClick = ({ rowData }) => {
    this.setState({
      selectedOutage: rowData,
      showEdit: true,
      message: null,
    });
  };

  formatDate = ({ cellData }) => {
    if (!cellData) {
      return "";
    }
    const dtValue = moment(cellData);
    if (dtValue.isValid()) {
      return dtValue.format("YYYY-MM-DD HH:mm:ss");
    }
    return "";
  };

  setSuccessMessage = (message) => {
    this.setState({ message, showEdit: false, selectedOutage: null });
  };

  render() {
    const {
      rowHeight,
      headerHeight,
      overscanRowCount,
      sortBy,
      sortDirection,
      loading,
      data,
      showEdit,
      selectedOutage,
    } = this.state;

    return (
      <div className="positionUnderHeader">
        <div style={{ height: "100%", paddingLeft: "2%", paddingRight: "2%" }}>
          {loading ? (
            "Loading....Please wait"
          ) : showEdit ? (
            <OutageEdit
              outage={selectedOutage}
              setSuccessMessage={this.setSuccessMessage}
              onCancel={() =>
                this.setState({
                  showEdit: false,
                  selectedOutage: null,
                  message: null,
                })
              }
            />
          ) : (
            <>
              <div className="screenHeader">
                <b>Outage List</b>
              </div>
              <div
                id="accordion"
                className="ui-widget-TableHeader outage-header"
              >
                <Button
                  bsStyle="secondary"
                  className="adminButton"
                  onClick={() =>
                    this.setState({ showEdit: true, isEdit: false })
                  }
                >
                  Create Outage
                </Button>
                <div>
                  <span>
                    <b> Search: </b>
                  </span>
                  <input
                    type="text"
                    onChange={(event) =>
                      this._filterRecordsOfTheTable(event.target.value)
                    }
                  />
                </div>
              </div>
              {this.state.message && (
                <Alert
                  bsStyle="success"
                  onDismiss={() => this.setState({ message: null })}
                >
                  <p>{this.state.message}</p>
                </Alert>
              )}
              <ContentBox className="currentSchematic">
                <div style={{ height: "85vh" }}>
                  <AutoSizer>
                    {({ height, width }) => (
                      <Table
                        ref="Table"
                        disableHeader={false}
                        headerClassName="outageHeaderColumn"
                        width={width}
                        height={height}
                        headerHeight={headerHeight}
                        rowHeight={rowHeight}
                        overscanRowCount={overscanRowCount}
                        rowCount={data.length}
                        rowClassName={this._rowClassName}
                        sort={this._sort}
                        sortBy={sortBy}
                        sortDirection={sortDirection}
                        onRowDoubleClick={this.onRowDoubleClick}
                        noRowsRenderer={this._noRowsRenderer}
                        rowGetter={({ index }) => data[index]}
                      >
                        <Column
                          width={width * 0.16}
                          label="Outage System"
                          dataKey="outageSystem"
                        />
                        <Column
                          width={width * 0.4}
                          label="Outage Message"
                          dataKey="outageMessage"
                        />
                        <Column
                          width={width * 0.16}
                          label="Last Maintenance Id"
                          dataKey="lastMaintenanceId"
                        />
                        <Column
                          width={width * 0.25}
                          label="Banner Start Date Time"
                          dataKey="bannerStartDateTime"
                          cellRenderer={this.formatDate}
                        />
                        <Column
                          width={width * 0.25}
                          label="Last Maintenance Date Time"
                          dataKey="lastMaintenanceDateTime"
                          cellRenderer={this.formatDate}
                        />
                        <Column
                          width={width * 0.25}
                          label="Outage Start Date Time"
                          dataKey="outageStartDateTime"
                          cellRenderer={this.formatDate}
                        />
                        <Column
                          width={width * 0.25}
                          label="Outage End Date Time"
                          dataKey="outageEndDateTime"
                          cellRenderer={this.formatDate}
                        />
                        <Column width={0} dataKey="id" />
                      </Table>
                    )}
                  </AutoSizer>
                </div>
              </ContentBox>
            </>
          )}
        </div>
      </div>
    );
  }
}
